import { action, makeObservable, observable } from 'mobx';

export class AutoAnomaliesUiState {
  @observable editing = false;

  constructor() {
    makeObservable(this);
  }

  @action.bound
  setEditing(value: boolean) {
    this.editing = value;
  }
}
